var map = {
  "./bialystok.png": "55221",
  "./bydgoszcz.png": "80944",
  "./gdansk.png": "68589",
  "./gdynia.png": "69965",
  "./gliwice.png": "93349",
  "./katowice.png": "22036",
  "./kielce.png": "30860",
  "./krakow.png": "73098",
  "./lodz.png": "63914",
  "./lublin.png": "17989",
  "./olsztyn.png": "84996",
  "./opole.png": "83030",
  "./poznan.png": "62153",
  "./rzeszow.png": "71507",
  "./szczecin.png": "22322",
  "./torun.png": "79909",
  "./warszawa.png": "82629",
  "./wroclaw.png": "56232"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 63465;
var map = {
  "./bialystok.png": "55221",
  "./bydgoszcz.png": "80944",
  "./gdansk.png": "68589",
  "./gdynia.png": "69965",
  "./gliwice.png": "93349",
  "./katowice.png": "22036",
  "./kielce.png": "30860",
  "./krakow.png": "73098",
  "./lodz.png": "63914",
  "./lublin.png": "17989",
  "./olsztyn.png": "84996",
  "./opole.png": "83030",
  "./poznan.png": "62153",
  "./rzeszow.png": "71507",
  "./szczecin.png": "22322",
  "./torun.png": "79909",
  "./warszawa.png": "82629",
  "./wroclaw.png": "56232"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 63465;
